import React from 'react'
import Header from '../Header'
import { Box ,Card,Grid,Button,Typography} from '@mui/material'
import { styles } from '../../styles/styles';
import {DecorativeCorner} from '../../common/DecorativeCorner';
import { useNavigate } from 'react-router-dom';
import PersonIcon from "@mui/icons-material/Person";
import SendIcon from "@mui/icons-material/Send";
import Footer from '../Footer';
const SuggestedProfile = () => {
const navigate=useNavigate();
    const Suggested = [
        {
          id: 1,
          image: "/images/women.jpeg",
          name: "Gayatri Devi",
          profession: "Software Engineer",
          Profileid: "AM101302",
          Age: "28",
          Location: "Bangalore",
        },
        {
          id: 2,
          image: "/images/women.jpeg",
          name: "Gayatri Devi",
          profession: "Software Engineer",
          Profileid: "AM102345",
          Age: "30",
          Location: "Hyderabad",
        },
        {
          id: 3,
          name: "Gayatri Devi",
          image: "/images/women.jpeg",
          profession: "Software Engineer",
          Profileid: "AM103567",
          Age: "26",
          Location: "Chennai",
        },
        {
          id: 4,
          image: "/images/women.jpeg",
          name: "Gayatri Devi",
          profession: "Software Engineer",
          Profileid: "AM103567",
          Age: "26",
          Location: "Chennai",
        },
        {
            id: 5,
            image: "/images/women.jpeg",
            name: "Gayatri Devi",
            profession: "Software Engineer",
            Profileid: "AM103567",
            Age: "26",
            Location: "Chennai",
          },
      ];
    
    return (
        <Box>
            <Header />
            <Card 
            sx={{...styles.cardsuggetion,
                marginTop:{xs:"20%",sm:"10%"},
                height:"100%",
                padding:{xs:"10%",sm:"40px"},
            }}
            >
               <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                {
                    Suggested &&(
                        <Grid container spacing={3}>
                        {Suggested.map((profile) => (
                          <Grid item xs={12} sm={4} md={4} lg={3} xl={4} key={profile.id}>
                            <Card
                              sx={{
                                textAlign: "center",
                                width: "100%",
                                maxWidth: "310px",
                                padding: { xs: "15px", sm: "10px" },
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                border: "2px solid rgb(224, 141, 64)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 2,
                                margin: "0 auto",
                                height:{xs:"auto",sm:"280px"}
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: { xs: "column", sm: "row" },
                                  alignItems: "center",
                                  gap: 3,
                                  textAlign: { xs: "center", sm: "left" },
                                }}
                              >
                                <img
                                  src={profile.image}
                                  alt={profile.name}
                                  style={{ width: "80px", height: "80px", borderRadius: "50%" }}
                                />
                                <Box>
                                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                    {profile.name}
                                  </Typography>
                                  <Typography sx={{ fontSize: "14px", color: "gray" }}>
                                    {profile.profession}
                                  </Typography>
                                </Box>
                              </Box>
        
                              <Box
                                sx={{
                                  textAlign: "center",
                                  width: "100%",
                                  padding: { xs: "0 40px ", sm: "0 50px" },
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: { xs: "row", sm: "row" },
                                    gap: { xs: 1, sm: 0 },
                                  }}
                                >
                                  <span style={{ fontWeight: "bold" }}>Profile ID:</span>
                                  <span>{profile.Profileid}</span>
                                </Typography>
        
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: { xs: "row", sm: "row" },
                                    gap: { xs: 1, sm: 0 },
                                  }}
                                >
                                  <span style={{ fontWeight: "bold" }}>Age:</span>
                                  <span>{profile.Age}</span>
                                </Typography>
        
                                <Typography
                                  sx={{
                                    fontSize: "14px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: { xs: "row", sm: "row" },
                                    gap: { xs: 1, sm: 0 },
                                  }}
                                >
                                  <span style={{ fontWeight: "bold" }}>Location:</span>
                                  <span>{profile.Location}</span>
                                </Typography>
                              </Box>
        
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  gap: 2,
                                  marginTop: "10px",
                                  flexWrap: "wrap",
                                }}
                              >
                                <Button
                                  variant="contained"
                                  sx={{
                                    backgroundColor: "rgb(183, 113, 8)",
                                    color: "white",
                                    borderRadius: "10px",
                                    padding: { xs: "8px 12px", sm: "15px 25px" },
                                    fontSize: { xs: "12px", sm: "14px" },
                                  }}
                                  onClick={() => navigate(`/profile/ProfileView`)}
                                >
                                  View Details
                                </Button>
                                <Box sx={{ display: "flex", gap: 1 }}>
                                  <PersonIcon
                                    sx={{
                                      backgroundColor: "green",
                                      color: "white",
                                      padding: { xs: "6px", sm: "8px" },
                                      borderRadius: "5px",
                                      fontSize: { xs: "25px", sm: "30px" },
                                    }}
                                  />
                                  <SendIcon
                                    sx={{
                                      backgroundColor: "green",
                                      color: "white",
                                      padding: { xs: "6px", sm: "8px" },
                                      borderRadius: "5px",
                                      fontSize: { xs: "25px", sm: "30px" },
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Card>
                          </Grid>
                        ))}
                      </Grid>
                    )
                }
            </Card>
            <Footer/>
        </Box>
    )
}

export default SuggestedProfile